<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Sản phẩm</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            text
            class="mb-2 mr-2"
            @click="showFilterDialog"
          >
            <v-icon class="mr-2">mdi-filter-variant-plus</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp">
              tìm nâng cao
            </span>
          </v-btn>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            :businessId="parseInt(bussId)"
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <FormFilter 
            :showDialog="dialogFilter"
            @confirmed="onFilterConfirmed" 
            @cancelled="onFilterCancelled"
          />
          <Process
            :showDialog="dialogProcess"
            :item="item"
            @confirmed="onProcessConfirmed" 
            @cancelled="onProcessCancelled"
          />
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
                <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogTraceCode"
            persistent
            max-width="500"
          >
            <v-card>
              <v-card-title class="headline">
                Thông báo!
              </v-card-title>
              <v-card-text>Bạn có muốn kích hoạt mã truy xuất cho sản phẩm này?</v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="pink darken-1"
                  text
                  @click="closeTraceCode"
                >
                  Hủy bỏ
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  text
                  @click="traceCodeConfirm"
                >
                  Đồng ý
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.gia_ban="{ item }">
        {{ item.gia_ban | currency('đ') }}
      </template>
      <template v-slot:item.anh_dai_dien="{ item }">
        <v-img
          v-if="item.anh_dai_dien"
          :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
          lazy-src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="green"
              />
            </v-row>
          </template>
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
        </v-img>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="blue"
              v-bind="attrs"
              v-on="on"
              @click="getProcess(item)"
            >
              <v-icon>
                mdi-autorenew
              </v-icon>
            </v-btn>
          </template>
          <span>Quy trình</span>
        </v-tooltip>
        <v-tooltip v-if="!item.ma_truy_xuat" left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="warning"
              v-bind="attrs"
              v-on="on"
              @click="traceCode(item)"
            >
              <v-icon>
                mdi-qrcode-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Tạo mã truy xuất</span>
        </v-tooltip>
        <v-tooltip v-else left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="warning"
              v-bind="attrs"
              v-on="on"
              @click="printCode(item)"
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>In mã truy xuất</span>
        </v-tooltip>
        <v-btn
          icon
          color="primary"
          @click="editItem(item)"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          color="pink"
          @click="deleteItem(item)"
        >
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogPrinter"
      persistent
      scrollable
      max-width="400"
    >
      <v-card>
        <v-app-bar
          dark
          color="info"
        >
          <v-toolbar-title>In mã truy xuất</v-toolbar-title>
          <v-spacer/>
          <v-btn
            icon
            @click="dialogPrinter=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <v-row 
              id="qrPrintElem" 
              class="mt-2"
            >
              <v-col
                align="center"
                justify="center"
                cols="6"
                v-for="i in listQr"
                :key="i"
                class="mx-auto"
              >
                <v-sheet v-if="qrItem"> 
                  <qrcode-vue 
                    :value="GenerateURL(qrItem)"
                    :size="100" 
                    level="H"
                  />
                  <div class="font-weight-light mt-2">
                    {{qrItem.ten_sp}}
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pa-4">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="codeQty"
                dense
                outlined
                label="Số lượng"
                placeholder="Số lượng"
                type="number"
                autofocus
                single-line
                hide-details
                clearable
                append-icon="mdi-play"
                @click:append="listQr=parseInt(codeQty)"
                autocomplete="off"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                color="success"
                v-print="'#qrPrintElem'"
                block
              >
                In ngay
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
  import QrcodeVue from 'qrcode.vue';
  import FormFilter from '@/views/admin/products/Filter';
  import Form from '@/views/admin/products/Form';
  import Process from '@/views/admin/products/Process';
  import { mapState } from 'vuex';
  export default {
    components: {
      Form,
      QrcodeVue,
      FormFilter,
      Process
    },
    props: {
      bussId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      dialogFilter: false,
      dialogProcess: false,
      dialogTraceCode: false,
      dialogPrinter: false,
      qrItem: null,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Ảnh', value: 'anh_dai_dien' },
        { text: 'Truy xuất', value: 'ma_truy_xuat' },
        { text: 'Tên', value: 'ten_sp' },
        { text: 'Loại', value: 'product_type.ten_loai' },
        { text: 'Giá bán', value: 'gia_ban' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      options: {},
      items: [],
      editedIndex: -1,
      item: {},
      filters: [
        {
          key: "type",
          title: 'Loại'
        }
      ],
      filterSelected: [],
      filter_rs: {
        type: {

        },
      },
      codeQty: 1,
      listQr: 1,
      filter: {

      }
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      anotherArrayName() {
        return this.filterSelected.map(item => item.key);
      },
      filteredItems() {
        return this.items.filter((i) => {
          return !this.filter_rs.type.ten_loai || (i.product_type.ten_loai === this.filter_rs.type.ten_loai);
        });
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    mounted () {
      if(this.$route.params.show){
        this.showDialog();
      }
    },
    methods: {
      initialize () {
        this.loading = true;
        const { page, itemsPerPage } = this.options;
        let pageNumber = page;
        let business_id = null;
        if(this.bussId){
          business_id = this.bussId;
        }
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            business_id: business_id,
            keyword: this.search,
            from: this.filter.tuNgay,
            to: this.filter.denNgay,
            type: this.filter.loaiSp
          }
        };
        axios.get("api/v1/products", request)
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
            this.numberOfPages = response.data.to;
            this.page = response.data.current_page;
            app.perPage = response.data.per_page;
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      showFilterDialog(){
        this.dialogFilter = true;
      },
      onFilterConfirmed(filter) {
        this.filter=filter;
        this.initialize();
        this.dialogFilter = false;
      },
      onFilterCancelled () {
        this.dialogFilter = false;
      },
      getProcess(item){
        this.item=Object.assign({}, item);
        this.dialogProcess=true;
      },
      onProcessConfirmed() {
        this.dialogProcess = false;
      },
      onProcessCancelled () {
        this.dialogProcess = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/products/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
          }).catch(function (error) {
            console.log(error);
          });
      },
      traceCode(item){
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogTraceCode = true;
      },
      traceCodeConfirm(){
        const app = this;
        axios.post(`api/v1/update-trace-code/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeTraceCode();
          }).catch(function (error) {
            console.log(error);
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeTraceCode () {
        this.dialogTraceCode = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      isInclude(name) {
        return this.anotherArrayName.includes(name);
      },
      removeFilterItem(name){
        let index = this.filterSelected.indexOf(name);
        this.filterSelected.splice(index, 1);
      },
      GenerateURL(item=null){
        let path = this.$router.resolve({
          name: 'ProductTrace', 
          params: {
            id: !item ? this.qrItemId : item.id
          }
        });
        return `${window.location.origin}/${path.href}`;
      },
      printCode(item){
        this.qrItem = item;
        this.dialogPrinter = true;
      }
    }
  }
</script>